import styled from 'styled-components';

const Container = styled.div`
  font-size: 12px;
  color: #161d1f;

  span {
    color: #4f6168;
  }
`;

export { Container };
